import { Typography } from '@mui/material';
import { Transition } from 'react-transition-group';
import { useState } from 'react';

import ThemeProvider from '@toolbox/style/theme/common/ThemeProvider/ThemeProvider';

import type { TransitionStatus } from 'react-transition-group';
import type React from 'react';

interface LoadingAnimatedIconProps {
  text?: string | null;
}

const DEFAULT_TEXT = ['Einen Moment noch', 'Gleich geschafft'];
const TRANSITION_DURATION = 300;
const TOTAL_ANIMATION = 2400 - TRANSITION_DURATION * 2;

const defaultStyle = {
  transition: `opacity ${TRANSITION_DURATION}ms ease-in-out`,
  opacity: 0,
};

const transitionStyles: Partial<Record<TransitionStatus, React.CSSProperties>> = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

export const LoadingAnimatedText: React.FC<LoadingAnimatedIconProps> = ({ text }) => {
  const textArr = text?.split(', ') || DEFAULT_TEXT;
  const [activeIndex, setActiveIndex] = useState(0);
  const [prevAnimationIsDone, setPrevAnimationIsDone] = useState(true);
  return (
    <ThemeProvider>
      {/*fixed height to prevent jumping content below animation elements*/}
      <div style={{ height: '30px' }}>
        {textArr.map((t, index) => (
          <Transition
            key={t}
            in={activeIndex === index && prevAnimationIsDone}
            timeout={TRANSITION_DURATION}
            mountOnEnter={true}
            unmountOnExit={true}
            appear={true}
            onEntered={() => {
              if (index + 1 !== textArr.length)
                setTimeout(() => {
                  setActiveIndex(activeIndex + 1);
                  setPrevAnimationIsDone(false);
                }, TOTAL_ANIMATION);
            }}
            onExit={() => {
              setTimeout(() => {
                setPrevAnimationIsDone(true);
              }, TRANSITION_DURATION);
            }}
          >
            {(state) => {
              return (
                <div
                  style={{
                    ...defaultStyle,
                    ...transitionStyles[state],
                  }}
                >
                  <Typography noWrap variant="h4">
                    {t}
                  </Typography>
                </div>
              );
            }}
          </Transition>
        ))}
      </div>
    </ThemeProvider>
  );
};
